import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, Input} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import {updateQuestion} from "scenes/Survey/Structure/data/questions/actions";
import { connect } from 'react-redux';
import LaddaButton, {ZOOM_OUT} from "react-ladda";

class ModalComment extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      comment: props.question.comment
    };

    this.save = this.save.bind(this);
  }

  save() {
    this.setState({saving: true});

    this.props.updateQuestion({id: this.props.question.id, question: {comment: this.state.comment}})
      .then(() => {
        this.setState({saving: false});
        this.props.toggleModal();
      });
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggleModal}>
        <ModalHeader toggle={this.props.toggleModal} tag="h2"><FormattedMessage id="question.headerActions.modalComment.modal.modalHeader"/></ModalHeader>
        <hr className="my-0" />
        <ModalBody>
          <Input type="textarea" value={this.state.comment} onChange={(e) => this.setState({comment: e.target.value})} rows="5"/>
        </ModalBody>
        <ModalFooter>
          <div className="direction-group d-flex justify-content-end">
            <div className="direction-right">
              <FormattedMessage id="_.button.save">{
                (message) => <LaddaButton
                  className="btn btn-success btn-ladda mb-0 ml-3"
                  loading={this.state.saving}
                  data-style={ZOOM_OUT}
                  onClick={this.save}
                >
                  {message}
                </LaddaButton>
              }</FormattedMessage>
              <FormattedMessage id="_.button.cancel">{
                (message) => <Button color="secondary" onClick={this.props.toggleModal} className="mb-0 ml-3">{message}</Button>
              }</FormattedMessage>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

ModalComment.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    comment: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired
};

export default connect(null, {updateQuestion})(ModalComment);